<template>
  <div class="menu-item-wrapper">

    <!-- آیتم دارای زیرمنو -->
    <div class="dropdown" v-if="hasChildren">
      <a href="javascript:void(0)" class="dropdown-toggle base-menu-item text-dark text-decoration-none">
        <m-menu-icon-manager :item="item"/>
        <span class="base-menu-item-text-simple ">{{ item.name }}</span>
      </a>
      <div class="dropdown-menu " :class="{ 'dropdown-submenu-left': isSubmenu }">
        <base-menu-item
            v-for="child in item.children"
            :key="child.id"
            :item="child"
        />
      </div>

    </div>

    <!-- آیتم ساده -->
    <m-a
        v-else
        class="dropdown-item text-dark text-decoration-none"
        :href="item.url"
    >
      <m-menu-icon-manager :item="item"/>
      <span class="base-menu-item-text">{{ item.name }}</span>
    </m-a>

  </div>
</template>

<script>
import mA from '../Tags/A'
import mMenuIconManager from './MenuIconManager.vue'

export default {
  name: 'BaseMenuItem',
  components: {
    mMenuIconManager,
    mA,
    BaseMenuItem: () => import('./BaseMenuItem.vue') // بازگشتی
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0
    },
    isSubmenu() {
      return this.$parent.$options.name === 'BaseMenuItem' // یعنی داخل یه BaseMenuItem دیگه هست
    }
  }

}
</script>

<style scoped>
.menu-item-wrapper {
  font-size: 0.85rem;
  font-weight: bold;
  direction: rtl;
  padding: 8px 0;
}

.dropdown {
  transition: all 0.3s ease !important;
  position: relative;
}



/* منوی سطح اول (زیر دکمه) */
.dropdown-menu {
  transition: all 0.3s ease;
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 200px;
  background: white;
  z-index: 1000;
  padding: 24px 0;
  border-radius: 0 !important;

}

/* فعال شدن منو با هاور */
.dropdown:hover > .dropdown-menu {
  transition: all 0.3s ease;

  display: block;
  text-align: right;
}

/* زیرمنوی داخلی: باز شدن به سمت چپ */
.dropdown-submenu-left {
  transition: all 0.3s ease;
  top: -10px;
  right: 100%;
  left: auto;
  margin-right: 0;
  margin-left: 0;
  padding: 20px 8px;

}

.base-menu-item-text-simple{
  margin: 0 4px;


}

.base-menu-item{
  margin: 0 8px;
  padding: 16px 0;
}

.dropdown :hover{
  transition: all 0.3s ease !important;
  color: var(--primary) !important;

}

</style>
